module.exports = __webpack_public_path__ + "img/90f7f1d.jpg";